// extracted by mini-css-extract-plugin
export var checkboxInputRow = "G_v8";
export var checkboxInputColumn = "G_v9";
export var inputOptionRow = "G_sq";
export var inputOptionColumn = "G_sr";